import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { AppState } from '../../../store/reducers/root';
import { getProjectInfo } from '../../../store/selectors/session';
import { isDarkTheme } from '../../../store/selectors/theme';

import AboutPreferencesPane from './AboutPreferencesPane';

const mapStateToProps = (state: AppState) => ({
  isDarkTheme: isDarkTheme(state),
  projectInfo: getProjectInfo(state),
});
const connector = connect(mapStateToProps);

export type AboutPreferencesPaneContainerProps = ConnectedProps<
  typeof connector
>;

export default connector(AboutPreferencesPane);
